// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"f282d068","911":"e5340c3d"}[chunkId] + ".chunk.js";
};